import React from 'react';

import { TranslatedMessage } from 'common/components/Intl';

import Modal from 'common/components/modals/Modal';
import CommitmentText from 'apps/cart/components/CommitmentText';

interface Props {
  isOpen: boolean;
  toggleModal(openState: boolean): void;
}

export const CommitmentDetailsModal: React.FC<Props> = props => {
  const { isOpen, toggleModal } = props;
  return (
    <>
      <a
        onClick={() => toggleModal(true)}
        className="label product-information__header__price__details"
      >
        <TranslatedMessage id={'cart.commitment_details_modal.details'} />
      </a>
      <Modal isOpen={isOpen} onRequestClose={() => toggleModal(false)}>
        <CommitmentText {...props} />
      </Modal>
    </>
  );
};
